import api from "./api";

class SupportManager {

    creaSupporto(data: any) {
        return api.post(`/support`, data)
    }
    checkNinjaAuth() {
        return api.get(`/check_ninja_auth`)
    }
    syncContacts() {
        return api.get(`/sincronizza_contatti`)
    }

}

const supportManager = new SupportManager()

export default supportManager
